import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Dashboard from "../pages/Dashboard";
import Home from "../pages/Authentication/Home";
import Campaigns from "../pages/Campaigns";
import Statements from "../pages/Statements";
import Members from "../pages/Members";
import ExportedRequests from "../pages/ExportedRequests";
import Profile from "../pages/Settings/Profile";
import UserVerify from "../pages/Authentication/UserVerify";
import Register from "../pages/Authentication/Register";
import Rewards from "../pages/Rewards";
import ResetPassword from "../pages/Authentication/ResetPassword";
import { Navigate } from "react-router-dom";

export const publicRoutes = [
  { path: "/login", element: <Login /> },
  { path: "/register", element: <Register /> },
  { path: "/reset-password", element: <ResetPassword /> },
  { path: "/verify", element: <UserVerify /> },
  { path: "/logout", element: <Logout /> },
  { path: "/", element: <Navigate to="/login" /> },
];

export const authProtectedRoutes = [
  { path: "/dashboard", element: <Dashboard /> },
  { path: "/campaigns", element: <Campaigns /> },
  { path: "/statements", element: <Statements /> },
  { path: "/rewards", element: <Rewards /> },
  { path: "/members", element: <Members /> },
  { path: "/exported-requests", element: <ExportedRequests /> },
  { path: "/settings/profile", element: <Profile /> },
];
